import router from "../router"
import api from "../api"
import ls from "@/helper/ls"

const user = ls.getKey("baltlan_ai")
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ dispatch, commit }, { username, password }) {
      try {
        const response = await api.login({ username, password })
        console.log("🚀 ~ response:", response)

        if (response?.accessToken) {
          ls.setKey("baltlan_ai", response)
          commit("loginSuccess", response)
          router.push("/")
          return response
        } else {
          return { isError: true, message: response.data?.message || "" }
        }
      } catch (error) {
        return { isError: true, message: response.data?.message || "" }
      }
    },
    logout({ commit }) {
      ls.removeKey("baltlan_ai")
      commit("logout")
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status = { loggedIn: true }
      state.user = user
    },
    loginFailure(state) {
      state.status = {}
      state.user = null
    },
    logout(state) {
      state.status = {}
      state.user = null
    },
  },
}
